import authenticationApi from "./authentication/api";
import authentication from './authentication/router';

import accountApi from "./account/api";
import account from './account/router';

import roomsApi from "./rooms/api";
import rooms from './rooms/router';

const mergeing = [account, authentication, rooms]
let indexs = {}
let components = []

mergeing.map(component => {
    if (Object.keys(component).length > 0) {
        Object.keys(component).map(comp => {
            if (component[comp].children) {
                if (indexs[comp] > -1) {
                    components[indexs[comp]].children.push(...component[comp].children)
                } else {
                    indexs[comp] = components.length
                    components.push(component[comp])
                }
            } else {
                components.push(component[comp])
            }
        })
    }
})

export default {
    api: {
        ...authenticationApi,
        ...accountApi,
        ...roomsApi,
    },
    routre: components,
}